import React, { Component } from "react";
import { MenuItem, Paper, Select } from "@material-ui/core";
import { connect } from "react-redux";
import {
  getNewPurchaseFundList,
  getFundWiseEarnings,
} from "../../../store/actions";
import {
  ALL,
  GET_FUNDS_LIST,
  GET_FUNDS_LIST_SUCCESS,
  GET_FUNDS_LIST_FAILED,
} from "../../../store/types";
import CustomLoading from "../CustomLoader";
import { FormatCurrency } from "../currencyFormatter";
import IntegrationReactSelect from "../../forms/autoCompleteInput";

export const MyEarnings_URL = `/my-earnings`;

class MyEarnings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFund: 0,
    };
  }
  async componentDidMount() {
    const params = {
      opt: ALL,
    };
    const types = [
      GET_FUNDS_LIST,
      GET_FUNDS_LIST_SUCCESS,
      GET_FUNDS_LIST_FAILED,
    ];
    const response = await this.props.getNewPurchaseFundList(params, types);
    if (response) {
      const { Dtinformation: funds = [] } = response;
      const fundId = funds[0].amc_code;
      this.getEarnings(fundId);
    }
  }

  getEarnings = (id, index) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.setState({ selectedFund: index || 0 });
    const params = {
      ReqBy: ALL,
      Agent: this.props.token,
      Fund: id,
    };
    this.props.getFundWiseEarnings(params);
  };

  get total() {
    const { earnings = [] } = this.props;
    return earnings.reduce((prev, curr) => prev + curr.Amount, 0);
  }

  render() {
    const { fundsList = [], earnings = [], count } = this.props;
    const { selectedFund } = this.state;
    return (
      <div style={{ margin: "20px 30px 30px 8px" }}>
        <div className="investor-title">My Earnings</div>

        <div className=" d-sm-none mb-2 bg-white">
          {/* <IntegrationReactSelect
                value={fundsList[this.state.selectedFund]&&fundsList[this.state.selectedFund].amc_code}
                suggestions={fundsList.map(f => ({label:f.amc_name,value:f.amc_code}))}
                handleChange={
                  (fundOption) => 
                  
                    this.getEarnings(fundOption.value,fundsList.findIndex(f=>f.amc_code== fundOption.value))
              }

            /> */}
          <Select
            variant="outlined"
            value={
              fundsList[this.state.selectedFund] &&
              fundsList[this.state.selectedFund].amc_code
            }
            onChange={(e) =>
              this.getEarnings(
                e.target.value,
                fundsList.findIndex((f) => f.amc_code == e.target.value)
              )
            }
            style={{ width: "100%" }}
          >
            {fundsList.map((f) => (
              <MenuItem value={f.amc_code}>{f.amc_name}</MenuItem>
            ))}
          </Select>
        </div>

        {count > 0 && !fundsList.length ? (
          <CustomLoading type="ThreeDots" height={100} width={100} />
        ) : (
          <Paper
            className="digital-form-container"
            style={{ boxShadow: "0px 0px 2px 0px lightgray", margin: 0 }}
          >
            <div className="digital-form-left-div d-none d-sm-block">
              {fundsList.map((fund, index) => (
                <div
                  key={index}
                  className="digital-form-investor-list"
                  style={{
                    backgroundColor:
                      index === selectedFund ? "#f3f9fd" : "#FFF",
                    cursor: "pointer",
                  }}
                  onClick={() => this.getEarnings(fund.amc_code, index)}
                >
                  <div
                    className={
                      index === selectedFund ? "digital-form-main-text" : ""
                    }
                  >
                    {fund.amc_name}
                  </div>
                </div>
              ))}
            </div>

            <div className="digital-form-Right-div">
              <div className="brokerage-details-responsive">
                <div
                  style={{
                    fontSize: 15,
                    fontFamily: "OpenSans-Bold",
                    marginBottom: 20,
                    color: "#981419",
                  }}
                >
                  Brokerage Details
                </div>
                <div
                  style={{
                    fontSize: 15,
                    fontFamily: "OpenSans-SemiBold",
                    color: "#0076cb",
                  }}
                >
                  Total: <FormatCurrency value={this.total} />
                </div>
              </div>
              {count > 0 ? (
                <CustomLoading type="ThreeDots" height={60} width={60} />
              ) : earnings?.length ? (
                earnings.map((earning, index) => (
                  <div key={index} style={{ marginBottom: 10, marginTop: 10 }}>
                    <div
                      style={{ fontFamily: "OpenSans-SemiBold", fontSize: 14 }}
                    >
                      {earning.BankName}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 5,
                        marginBottom: 20,
                      }}
                    >
                      <div>
                        <div
                          style={{
                            color: "#8b8b8b",
                            fontSize: 14,
                            fontFamily: "OpenSans-Regular",
                          }}
                        >
                          Period:
                        </div>
                        <div>
                          {earning.Fromdate} to {earning.ToDate}
                        </div>
                      </div>
                      <div>
                        <div
                          style={{
                            color: "#8b8b8b",
                            fontSize: 14,
                            fontFamily: "OpenSans-Regular",
                          }}
                        >
                          Amount
                        </div>
                        <div
                          style={{
                            fontSize: 14,
                            fontFamily: "OpenSans-SemiBold",
                          }}
                        >
                          <FormatCurrency value={earning.Amount} />
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        borderBottom: "1px solid lightgray",
                        marginTop: 10,
                      }}
                    />
                  </div>
                ))
              ) : (
                <div>No Data Found</div>
              )}
            </div>
          </Paper>
        )}
      </div>
    );
  }
}

export default connect(
  ({ transactions, authReducer, loading }) => {
    const { fundsList, earnings } = transactions;
    const { token } = authReducer;
    const { count } = loading;
    return { fundsList, token, earnings, count };
  },
  { getNewPurchaseFundList, getFundWiseEarnings }
)(MyEarnings);
